import getPower from '../../api/shop/getPower';
import SelectWithFetch from './SelectWithFetch';

const SelectPower = (props) => {
  return <SelectWithFetch fetch={getPower} label="Ð.Ð¡." placeholder="ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°" {...props} />;
};

export default SelectPower;
